import { NoShifts } from '../../../../../ui/components/NoShifts';
import { VolunteerPastShiftsTable } from '../../../../../ui/features/shift-details/components/past-shifts/VolunteerPastShiftsTable';
import { usePastShiftsTableFilterConfig } from '../../../../../ui/features/shift/hooks/usePastShiftsTableFilterConfig';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import React from 'react';
export const VolunteerPastShiftsView = ({ shifts, missionId, defaultRowsPerPage, additionalData, useDataTableProviderHandler, children }) => {
    const { t } = useMissionsTranslation();
    const { dataTableProps, filtersBarProps } = useDataTableUsingState({
        useDataProvider: (request) => useDataTableProviderHandler(request, Object.assign(Object.assign({}, additionalData), { filterData: {} })),
        defaultSortColumnKey: '', // There is no active sorting, comes sorted from DB
        defaultRowsPerPage,
        rowSelectionEnabled: true,
    });
    const filterConfig = usePastShiftsTableFilterConfig();
    if (shifts.length === 0) {
        return React.createElement(NoShifts, { description: t('missions.noPastShiftsForMission') });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(VolunteerPastShiftsTable, { dataTableProps: dataTableProps, filtersBarProps: filtersBarProps, filterConfig: filterConfig, defaultRowsPerPage: defaultRowsPerPage, missionId: missionId }, children)));
};
